import { render, staticRenderFns } from "./FormAreaPromoterCRM.vue?vue&type=template&id=4cb00bee&scoped=true"
import script from "./FormAreaPromoterCRM.vue?vue&type=script&lang=js"
export * from "./FormAreaPromoterCRM.vue?vue&type=script&lang=js"
import style0 from "./FormAreaPromoterCRM.vue?vue&type=style&index=0&id=4cb00bee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb00bee",
  null
  
)

export default component.exports